import { useState, useEffect } from "react";
import { useAuth } from "../../auth";
import { useAppSelector } from "../../../../redux/hooks";
import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import Highavailavility from "./highAvailability";
import RegisterCTXCrud from "./RegisterTable";
import Unlicenced from "./Unlicenced Devices";
import SyslogConfig from './SyslogConfig';
import HealthCheck from './HealthCheck';
import './ha/estiloscard.css';

function Devicescruds() {
  const { currentUser } = useAuth();
  const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions);
  const [flag, setflag] = useState<number>();
  const [num, setnum] = useState<number>();
  const [renderHighAvailability, setRenderHighAvailability] = useState(false);

  useEffect(() => {
    if (currentUser?.ListPermiso?.includes('CTXR.List')) {
      setflag(1);
    } else if (currentUser?.ListPermiso?.includes('CTXR.List')) {
      setflag(2);
    } else if (currentUser?.ListPermiso?.includes('CTXR.Cluster.List')) {
      setflag(3);
      setRenderHighAvailability(true);
    }
  }, [currentUser]);

  return (
    <div className='card'>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='f-titulo text-marino fs-md'>Instances Management</span>
        </h3>
      </div>
      <ul style={{ marginLeft: '25px', marginRight: '25px' }} className="nav nav-tabs nav-line-tabs mb-5 fs-6">
        {currentUser?.ListPermiso?.includes('CTXR.List') && (
          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="licensed"
              onClick={() => (setnum(1), setflag(1))}
            >
              Licensed Instances
            </NavLink>
          </li>
        )}
        {currentUser?.ListPermiso?.includes('CTXR.List') && (
          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="unlicensed"
              onClick={() => (setnum(2), setflag(2))}
            >
              Unlicensed Instances
            </NavLink>
          </li>
        )}
        {currentUser?.ListPermiso?.includes('CTXR.Cluster.List') && (
          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="highavailability"
              onClick={() => (setnum(3), setRenderHighAvailability(true), setflag(3))}
            >
              High Availability
            </NavLink>
          </li>
        )}
        {currentUser?.ListPermiso?.includes('CTXR.Neighbor.List') && (
          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="healthcheck"
            >
              Health Check
            </NavLink>
          </li>
        )}
        {currentUser?.ListPermiso?.includes('CTXR.Neighbor.List') && (
          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="syslog"
            >
              Syslog
            </NavLink>
          </li>
        )}
      </ul>
      <div style={{ marginLeft: '25px', marginRight: '25px' }} className="tab-content" id="myTabContent">
        <Routes>
          {(currentUser?.ListPermiso?.includes('CTXR.List') || !ListaPermisosTenant.includes('CTXR.List')) && (
            <Route path="licensed" element={<RegisterCTXCrud flag={flag} num={num} />} />
          )}
          {(currentUser?.ListPermiso?.includes('CTXR.List') || !ListaPermisosTenant.includes('CTXR.List')) && (
            <Route path="unlicensed" element={<Unlicenced num={num} />} />
          )}
          {(currentUser?.ListPermiso?.includes('CTXR.Cluster.List') || !ListaPermisosTenant.includes('CTXR.Cluster.List')) && (
            <Route path="highavailability" element={renderHighAvailability ? <Highavailavility tab={num} /> : null} />
          )}
          {(currentUser?.ListPermiso?.includes('CTXR.Neighbor.List') || !ListaPermisosTenant.includes('CTXR.Neighbor.List')) && (
            <Route path="healthcheck" element={<HealthCheck />} />
          )}
          {(currentUser?.ListPermiso?.includes('CTXR.Neighbor.List') || !ListaPermisosTenant.includes('CTXR.Neighbor.List')) && (
            <Route path="syslog" element={<SyslogConfig />} />
          )}
          {/* Default route */}
          {(currentUser?.ListPermiso?.includes('CTXR.List') || !ListaPermisosTenant.includes('CTXR.List')) ? (
            <Route path="*" element={<Navigate to="licensed" />} />
          ) : (
            <Route path="*" element={<Navigate to="/CTX-R/Management/neighbors" />} />
          )}
        </Routes>
      </div>
    </div>
  );
}

export default Devicescruds;
